/* eslint-disable max-len */
import React, { useState } from 'react'
import { Menu } from "@headlessui/react";
import { motion } from 'framer-motion'
import {useNavigate, useParams} from 'react-router-dom';
import { PaymentInfoModal } from './paymentInfoModal'
import { PaymentStatus } from '../../../../constant';
import Modal from '../../../../CommonComponent/Modal';
import ProcessingModal from './processingModal';
import { calculateBuyerFee } from '../../../../utils/calculateBuyerFee';
import ToolTip from '../../../../CommonComponent/tooltip';
 

export default function SaleTableBody({sales, onChangePaymentInfo, onSendPaymentReminder, onSendProccessPayment,
    handleSendPaymentRequest, isPaymentRequestEnabled, auctionData}) {
    const navigate = useNavigate()
    const {id,uid}=useParams();
    const [isPaymentInfoModalOpen, setIsPaymentInfoModalOpen] = useState(false)
    const [selectedSale, setSelectedSale] = useState(null)
    const [isConfirmProcessPaymentOpen, setIsConfirmProcessPaymentOpen] = useState(false)
    const [isProcessingModalOpen, setIsProcessingModalOpen] = useState(false)

    const dateConverter = (timestamp)=>{
        if(!timestamp || timestamp === 0) {
            return '-';
        }
        const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    
        // Format the date as "dd MMM yyyy"
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        }).format(date);
        return formattedDate;
    }

    const statusClasses =(status)=>{
        switch(status){
        case 'Paid':
            return 'bg-[#A8D9C8] text-[#489892]';
        case 'Failed':
            return 'bg-[#E3C79D] text-[#B98B47]';
        case 'Pending':
            return 'bg-[#E6E6E6] text-[#343434]';
        case 'Cancelled':
            return 'bg-[#DDD1D5] text-[#984848]';
        default :
            return 'bg-[#E2EDFF] text-[#000000B2]';
        }
    }

    return (
        <>
            {sales.map((sale,index)=>{
                const CREDIT_CARD_REGISTRATION = 'Register with credit card';
                const modalBuyerFees = sale.buyer_fees != null
                    ? 0
                    : calculateBuyerFee(sale.amount, auctionData);

                const canSendPaymentRequest = !isPaymentRequestEnabled
                    && sale.registration_type !== CREDIT_CARD_REGISTRATION
                    && sale.payment_status !== PaymentStatus.PAID
                    && sale.payment_status !== PaymentStatus.FAILED;

                const isFailedCardPayment = sale.registration_type === CREDIT_CARD_REGISTRATION
                    && sale.payment_status === PaymentStatus.FAILED;

                const showPaymentRequestOption = (canSendPaymentRequest || isFailedCardPayment)
                    && !sale.request_sent;

                const showPaymentReminderOption = !showPaymentRequestOption && sale.payment_status !== PaymentStatus.PAID;

                const showMailIcon = sale.payment_status == PaymentStatus.PENDING || sale.payment_status == PaymentStatus.FAILED;

                return (<motion.tr className="table-row h-14 "
                    key={index}
                    id= "list-items"
                    initial={{ opacity: 0, y: 0 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.002 }}
                >
                    <td className="text-[#343434] border-b border-[#DEDEDE] px-4 py-3 text-[14px] leading-normal font-medium text-center">
                        {sale.order_number ? sale.order_number : '-'}
                    </td>
                    <td className="text-[#343434] border-b border-[#DEDEDE] px-4 py-3 text-[14px] leading-normal font-medium text-center">
                        {sale.name==undefined?'-':sale.name}
                    </td>
                    <td className="text-[#343434] border-b border-[#DEDEDE] px-4 py-3 text-[14px] leading-normal font-medium text-center">
                        {sale.auction_title ? sale.auction_title : '-'}
                    </td>
                    <td className="text-[#343434] px-4 py-3 text-[14px] text-center leading-normal font-medium border-b border-[#DEDEDE]">
                        {(!sale.created_at || sale.created_at==='') ? '-' : dateConverter(sale.created_at)}
                    </td>
                    <td className="text-[#343434] px-4 py-3 text-[14px] text-center leading-normal font-medium max-w-[180px] truncate border-b border-[#DEDEDE]"
                        title={(sale.amount===0 || sale.amount===undefined) ? "-" : 
                            Number(sale.amount).toLocaleString(sale.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: sale.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })
                        } >
                        {(sale.amount===0 || sale.amount===undefined) ? "-" : 
                            Number(sale.amount).toLocaleString(sale.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: sale.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })
                        }
                    </td>
                    <td className="text-[#343434] px-4 py-3 text-[14px] text-center leading-normal font-medium border-b border-[#DEDEDE]">
                        {sale.payment ? sale.payment : '-'}
                    </td>
                    <td className='text-center border-b border-[#DEDEDE]'>
                        {sale.payment_status ? <span className={`${statusClasses(sale.request_sent ? "Request sent" : sale.payment_status)} px-4 py-3 text-[14px] text-center leading-normal font-medium 
                                min-w-[96px] rounded-[42px]`}>
                            {sale.request_sent ? "Request sent" : sale.payment_status}
                        </span> : '-'}
                    </td>

                    <td className="text-[#343434] text-[14px] border-b border-[#DEDEDE] leading-normal font-medium">
                        {(showMailIcon && sale.reminder_sent) && 
                        <ToolTip trigger="mouseenter" position="top"
                            content="Payment reminder sent">
                            <img src='/images/mailIcon.svg' alt='mail icon' />
                        </ToolTip>}
                    </td>

                    <td className=" sm:relative  sm:bg-transparent bg-[#fff]  sticky top-0 right-0 border-b border-[#DEDEDE]">
                        <div className=" sm:px-4 px-2 h-fit py-[43px] sm:shadow-none shadow-bs7 ">
                            <span className="flex justify-end ">
                                <Menu as="div" className="relative" >
                                    <Menu.Button>
                                        <img src="/images/three-dots-icon-black.svg" alt="img" 
                                            className="cursor-pointer three-dots-icon" type="button"
                                            id="dropdownMenuButton11"
                                            data-testid={`action-${index}`}/>
                                    </Menu.Button>
                                    <Menu.Items className="!max-h-none !overflow-visible">
                                        <div className="dropdown-cont absolute rounded-[10px] float-left 
                                                m-0 w-[200px] py-2 right-0 z-[50] px-2 list-none 
                                                border-none bg-white bg-clip-padding text-left text-base shadow-bs3 -top-[32px] !max-h-none !overflow-visible">
                                            <Menu.Item>
                                                <button type='button' data-testid="view_order"
                                                    onClick={()=>navigate(`/auctions/${id}/${uid}/order-details/${sale._id}`)}
                                                    className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto 
                                                    block w-full whitespace-nowrap bg-transparent pl-5 pr-7 py-2 
                                                    text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                                >View</button>
                                            </Menu.Item>
                                            <Menu.Item>
                                                <button type='button' data-testid="change_payment_info"
                                                    disabled={sale.payment_status === PaymentStatus.PAID}
                                                    onClick={() => setIsPaymentInfoModalOpen(true)}
                                                    className={`block w-full whitespace-nowrap bg-transparent pl-5 pr-7 py-2
                                                    text-[12px] font-medium text-[#343434] cursor-pointer text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                    ${sale.payment_status === PaymentStatus.PAID ? 'text-gray-400 cursor-not-allowed' : ''}`}
                                                >Change payment info</button>
                                            </Menu.Item>
                                            {showPaymentRequestOption &&
                                                <Menu.Item>
                                                    <button type='button' data-testid="send_payment_request"
                                                        onClick={()=> handleSendPaymentRequest(sale._id)}
                                                        className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto 
                                                    block w-full whitespace-nowrap bg-transparent pl-5 pr-7 py-2 
                                                    text-[12px] font-medium text-[#343434] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                                    >Send payment request</button>
                                                </Menu.Item>}
                                            {showPaymentReminderOption &&
                                                <Menu.Item>
                                                    <button
                                                        type='button'
                                                        data-testid="send_payment_reminder"
                                                        className="block w-full whitespace-nowrap bg-transparent pl-5 pr-7 py-2 
                                                        text-[12px] font-medium text-[#343434] cursor-pointer text-left hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                                        onClick={() => {
                                                            const email = sale.email_address || sale.email || null;
                                                            onSendPaymentReminder(sale._id, email);
                                                        }}
                                                    >Send payment reminder</button>
                                                </Menu.Item>
                                            }
                                            {((sale && sale.payment_status !== PaymentStatus.PAID && sale.registration_type == 'Register with credit card') &&
                                                <Menu.Item>
                                                    <button
                                                        type='button'
                                                        data-testid={`process-payment-${index}`}
                                                        className="block w-full whitespace-nowrap bg-transparent pl-5 pr-7 py-2
                                                        text-[12px] font-medium text-[#343434] cursor-pointer text-left
                                                        hover:bg-[#E6E6E6] hover:rounded-[11px]"
                                                        onClick={() => {
                                                            setSelectedSale(sale);
                                                            setIsConfirmProcessPaymentOpen(true);
                                                        }}
                                                    >Process payment</button>
                                                </Menu.Item>
                                            )}
                                        </div>
                                    </Menu.Items>
                                </Menu>
                            </span>  
                        </div> 
                    </td>
                    <PaymentInfoModal
                        isOpen={isPaymentInfoModalOpen}
                        setIsOpen={setIsPaymentInfoModalOpen}
                        handleOK={(data) => onChangePaymentInfo(sale._id, data)}
                        loader={false}
                        paymentStatus={sale.payment_status}
                        paymentType={sale.payment}
                        amount={sale.amount}
                        buyerFees={modalBuyerFees}
                        currency={sale.currency}
                    />
                </motion.tr>
                );
            })}
            <Modal
                isOpen={isConfirmProcessPaymentOpen}
                setIsOpen={setIsConfirmProcessPaymentOpen}
                notShowCancel={false}
                buttonText="Process"
                titleStyle="text-[22px] px-[40px]"
                title="Are you sure you want to process payment?"
                testid="process"
                description="By clicking 'confirm', you will be processing the payment to the customer's saved payment method."
                content={
                    selectedSale && (
                        <p className="text-center text-[14px] font-medium text-[#A1A1A9] pb-[20px]">
                            Order Total: {Number(selectedSale.amount +
                                (calculateBuyerFee(selectedSale.amount, auctionData) || 0)
                            ).toLocaleString(
                                selectedSale.currency === 'INR' ? 'en-IN' : 'en-US',
                                { style: 'currency', currency: selectedSale.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }
                            )}
                        </p>
                    )
                }
                handleAction={() => {
                    setIsConfirmProcessPaymentOpen(false);
                    setIsProcessingModalOpen(true);
                    onSendProccessPayment(selectedSale._id, () => setIsProcessingModalOpen(false));
                }}
            />
            <ProcessingModal
                isOpen={isProcessingModalOpen}
                onClose={() => setIsProcessingModalOpen(false)}
                sale={selectedSale}
            />
        </>
    )
}
